/**
 * Content library feed: lightbox + client-side pagination.
 */
(function () {
    'use strict';

    var activeLightbox = null;
    var lastTrigger = null;

    function refreshLucide(root) {
        if (window.lucide && typeof window.lucide.createIcons === 'function') {
            window.lucide.createIcons({
                root: root || document,
                attrs: { 'aria-hidden': 'true' },
            });
        }
    }

    function mountLightbox(lightbox) {
        if (!lightbox || lightbox.parentNode === document.body) {
            return;
        }
        document.body.appendChild(lightbox);
    }

    function setLightboxCaption(lightbox, author, description) {
        var media = lightbox.querySelector('.edas-content-library-lightbox__media');
        var body = lightbox.querySelector('.edas-content-library-lightbox__body');
        var authorEl = lightbox.querySelector('.edas-content-library-lightbox__author');
        var descEl = lightbox.querySelector('.edas-content-library-lightbox__description');
        if (!media || !body || !authorEl || !descEl) {
            return;
        }

        author = (author || '').trim();
        description = (description || '').trim();
        var hasAuthor = author.length > 0;
        var hasDescription = description.length > 0;

        authorEl.textContent = author;
        descEl.textContent = description;

        if (hasAuthor) {
            authorEl.removeAttribute('hidden');
        } else {
            authorEl.setAttribute('hidden', '');
        }
        if (hasDescription) {
            descEl.removeAttribute('hidden');
        } else {
            descEl.setAttribute('hidden', '');
        }

        if (hasAuthor || hasDescription) {
            body.removeAttribute('hidden');
            media.classList.add('has-caption');
        } else {
            body.setAttribute('hidden', '');
            media.classList.remove('has-caption');
        }
    }

    /**
     * Prefer visible post markup (survives attribute stripping / stale HTML cache).
     */
    function readCaptionFromTrigger(trigger) {
        var author = (trigger.getAttribute('data-author') || '').trim();
        var description = (trigger.getAttribute('data-description') || '').trim();
        var root = trigger.closest('.edas-content-library__post') || trigger.closest('.edas-entry-image');
        if (!root) {
            return { author: author, description: description };
        }

        if (!author) {
            var authorNode = root.querySelector('.edas-content-library__author, .edas-content-library__caption-author');
            if (authorNode) {
                author = (authorNode.textContent || '').trim();
            }
        }

        if (!description) {
            var caption = root.querySelector('.edas-entry-image__caption, .edas-content-library__caption');
            if (caption) {
                var clone = caption.cloneNode(true);
                var capAuthor = clone.querySelector('.edas-content-library__caption-author');
                if (capAuthor && capAuthor.parentNode) {
                    capAuthor.parentNode.removeChild(capAuthor);
                }
                description = (clone.textContent || '').trim();
            }
        }

        // Gallery-level caption shared by nested images.
        if (!description) {
            var gallery = trigger.closest('.wp-block-gallery');
            if (gallery) {
                var galleryCaption = gallery.querySelector(
                    'figcaption.blocks-gallery-caption, figcaption.edas-content-library__caption, .blocks-gallery-caption'
                );
                if (galleryCaption) {
                    var gClone = galleryCaption.cloneNode(true);
                    var gAuthor = gClone.querySelector('.edas-content-library__caption-author');
                    if (gAuthor && gAuthor.parentNode) {
                        gAuthor.parentNode.removeChild(gAuthor);
                    }
                    description = (gClone.textContent || '').trim();
                    if (!author) {
                        var gAuthorLive = galleryCaption.querySelector('.edas-content-library__caption-author');
                        if (gAuthorLive) {
                            author = (gAuthorLive.textContent || '').trim();
                        }
                    }
                }
            }
        }

        return { author: author, description: description };
    }

    /**
     * Imágenes hermanas navegables desde el lightbox (misma galería de la entrada).
     */
    function getTriggerGroup(trigger) {
        var gallery = trigger.closest('.wp-block-gallery');
        if (!gallery) {
            return [trigger];
        }
        return Array.prototype.slice.call(
            gallery.querySelectorAll('.edas-entry-image .edas-content-library__image-trigger')
        );
    }

    function updateLightboxNav(lightbox) {
        var group = lightbox._edasGroup || [];
        var hasNav = group.length > 1;
        lightbox.classList.toggle('has-nav', hasNav);
        lightbox.querySelectorAll('.edas-content-library-lightbox__nav').forEach(function (btn) {
            btn.hidden = !hasNav;
        });
    }

    function stepLightbox(lightbox, delta) {
        var group = lightbox._edasGroup || [];
        if (group.length < 2) {
            return;
        }
        var index = (lightbox._edasIndex + delta + group.length) % group.length;
        showTriggerInLightbox(lightbox, group[index], group, index);
    }

    function showTriggerInLightbox(lightbox, trigger, group, index) {
        var caption = readCaptionFromTrigger(trigger);
        lightbox._edasGroup = group;
        lightbox._edasIndex = index;
        lastTrigger = trigger;
        updateLightboxNav(lightbox);
        openLightbox(lightbox, {
            src: trigger.getAttribute('data-full-src') || '',
            alt: trigger.getAttribute('data-alt') || '',
            author: caption.author,
            description: caption.description,
        });
    }

    function openLightboxFromTrigger(trigger, lightbox) {
        var group = getTriggerGroup(trigger);
        var index = Math.max(0, group.indexOf(trigger));
        showTriggerInLightbox(lightbox, trigger, group, index);
    }

    function openLightbox(lightbox, options) {
        var img = lightbox.querySelector('.edas-content-library-lightbox__image');
        if (!img) {
            return;
        }

        var src = options.src || '';
        var alt = options.alt || '';
        var wasOpen = activeLightbox === lightbox;

        mountLightbox(lightbox);

        if (img.getAttribute('src') !== src) {
            lightbox.classList.add('is-loading');
            img.onload = img.onerror = function () {
                lightbox.classList.remove('is-loading');
            };
            img.src = src;
            if (img.complete) {
                lightbox.classList.remove('is-loading');
            }
        }
        img.alt = alt;
        setLightboxCaption(lightbox, options.author || '', options.description || '');
        if (wasOpen) {
            return;
        }
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        activeLightbox = lightbox;
        document.documentElement.classList.add('edas-content-library-lightbox-open');
        document.body.classList.add('edas-content-library-lightbox-open');

        var closeBtn = lightbox.querySelector('.edas-content-library-lightbox__close');
        if (closeBtn) {
            closeBtn.focus();
        }
        refreshLucide(lightbox);
    }

    function closeLightbox(lightbox) {
        if (!lightbox) {
            return;
        }

        var img = lightbox.querySelector('.edas-content-library-lightbox__image');
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');

        if (activeLightbox === lightbox) {
            activeLightbox = null;
        }

        document.documentElement.classList.remove('edas-content-library-lightbox-open');
        document.body.classList.remove('edas-content-library-lightbox-open');

        if (img) {
            img.onload = null;
            img.onerror = null;
            img.removeAttribute('src');
            img.alt = '';
        }
        lightbox.classList.remove('is-loading', 'has-nav');
        lightbox._edasGroup = null;
        setLightboxCaption(lightbox, '', '');

        if (lastTrigger && document.contains(lastTrigger)) {
            lastTrigger.focus({ preventScroll: true });
        }
        lastTrigger = null;
    }

    function bindLightboxSwipe(lightbox) {
        var startX = null;
        var startY = null;
        lightbox.addEventListener('touchstart', function (event) {
            if (event.touches.length !== 1) {
                startX = null;
                return;
            }
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
        }, { passive: true });
        lightbox.addEventListener('touchend', function (event) {
            if (startX === null || !event.changedTouches.length) {
                return;
            }
            var dx = event.changedTouches[0].clientX - startX;
            var dy = event.changedTouches[0].clientY - startY;
            startX = null;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                stepLightbox(lightbox, dx < 0 ? 1 : -1);
            }
        });
    }

    function getSharedLightbox() {
        var existing = document.getElementById('edas-content-library-lightbox-shared');
        if (existing) {
            return existing;
        }

        var lightbox = document.createElement('div');
        lightbox.id = 'edas-content-library-lightbox-shared';
        lightbox.className = 'edas-content-library-lightbox';
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        lightbox.innerHTML =
            '<div class="edas-content-library-lightbox__backdrop" data-lightbox-close></div>' +
            '<div class="edas-content-library-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Imagen a tamaño completo">' +
                '<button type="button" class="edas-content-library-lightbox__close" data-lightbox-close aria-label="Cerrar">' +
                    '<i data-lucide="x" aria-hidden="true"></i>' +
                '</button>' +
                '<button type="button" class="edas-content-library-lightbox__nav edas-content-library-lightbox__nav--prev" data-lightbox-step="-1" aria-label="Imagen anterior" hidden>' +
                    '<i data-lucide="chevron-left" aria-hidden="true"></i>' +
                '</button>' +
                '<button type="button" class="edas-content-library-lightbox__nav edas-content-library-lightbox__nav--next" data-lightbox-step="1" aria-label="Imagen siguiente" hidden>' +
                    '<i data-lucide="chevron-right" aria-hidden="true"></i>' +
                '</button>' +
                '<div class="edas-content-library-lightbox__media">' +
                    '<img class="edas-content-library-lightbox__image" src="" alt="" />' +
                    '<div class="edas-content-library-lightbox__body" hidden>' +
                        '<h3 class="edas-content-library-lightbox__author"></h3>' +
                        '<p class="edas-content-library-lightbox__description"></p>' +
                    '</div>' +
                '</div>' +
            '</div>';

        document.body.appendChild(lightbox);

        lightbox.addEventListener('click', function (event) {
            var step = event.target.closest('[data-lightbox-step]');
            if (step) {
                event.preventDefault();
                stepLightbox(lightbox, parseInt(step.getAttribute('data-lightbox-step'), 10) || 1);
                return;
            }
            if (event.target.closest('[data-lightbox-close]')) {
                event.preventDefault();
                closeLightbox(lightbox);
            }
        });
        bindLightboxSwipe(lightbox);

        return lightbox;
    }

    function bindEntryImages() {
        if (document.documentElement.dataset.edasEntryLightboxBound === '1') {
            return;
        }
        if (!document.querySelector('.edas-entry-image .edas-content-library__image-trigger')) {
            return;
        }

        document.documentElement.dataset.edasEntryLightboxBound = '1';
        var lightbox = getSharedLightbox();

        document.addEventListener('click', function (event) {
            var trigger = event.target.closest('.edas-entry-image .edas-content-library__image-trigger');
            if (!trigger) {
                return;
            }
            event.preventDefault();
            openLightboxFromTrigger(trigger, lightbox);
        });

        refreshLucide(document);
    }

    function bindLightbox(library, lightbox) {
        if (!lightbox || lightbox.dataset.lightboxBound) {
            return;
        }
        lightbox.dataset.lightboxBound = '1';
        mountLightbox(lightbox);

        lightbox.addEventListener('click', function (event) {
            if (event.target.closest('[data-lightbox-close]')) {
                event.preventDefault();
                closeLightbox(lightbox);
            }
        });

        library.addEventListener('click', function (event) {
            var trigger = event.target.closest('.edas-content-library__image-trigger');
            if (trigger && library.contains(trigger)) {
                event.preventDefault();
                openLightboxFromTrigger(trigger, lightbox);
            }
        });
    }

    function getHeaderOffset() {
        var header = document.querySelector('.edas-wp-header, .blur-fixed-header, .fixed-header, header');
        if (!header) {
            return 16;
        }
        var styles = window.getComputedStyle(header);
        var extra = 16;
        return Math.ceil(header.getBoundingClientRect().height) + extra;
    }

    function scrollToFirstVisiblePost(library) {
        var first = library.querySelector('.edas-content-library__post:not([hidden])');
        if (!first) {
            return;
        }
        var top = first.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
        window.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth',
        });
    }

    function updatePaginationUi(library, page, totalPages) {
        var nav = library.querySelector('.edas-content-library__pagination');
        if (!nav) {
            return;
        }

        var prev = nav.querySelector('[data-page-dir="prev"]');
        var next = nav.querySelector('[data-page-dir="next"]');
        var status = nav.querySelector('[data-page-status]');

        if (prev) {
            prev.disabled = page <= 1;
        }
        if (next) {
            next.disabled = page >= totalPages;
        }
        if (status) {
            var template = nav.getAttribute('data-status-template') || 'Página %1$s de %2$s';
            status.textContent = template
                .replace('%1$s', String(page))
                .replace('%2$s', String(totalPages));
        }

        library.setAttribute('data-current-page', String(page));
        nav.setAttribute('data-current-page', String(page));
    }

    function showPage(library, page) {
        var nav = library.querySelector('.edas-content-library__pagination');
        var totalPages = nav
            ? parseInt(nav.getAttribute('data-total-pages') || '1', 10)
            : 1;
        if (isNaN(totalPages) || totalPages < 1) {
            totalPages = 1;
        }

        page = Math.max(1, Math.min(totalPages, page));

        library.querySelectorAll('.edas-content-library__post').forEach(function (post) {
            var postPage = parseInt(post.getAttribute('data-page') || '1', 10);
            if (postPage === page) {
                post.hidden = false;
            } else {
                post.hidden = true;
                var video = post.querySelector('video');
                if (video && !video.paused) {
                    video.pause();
                }
            }
        });

        updatePaginationUi(library, page, totalPages);
        scrollToFirstVisiblePost(library);
        refreshLucide(library);
    }

    function initPagination(library) {
        var nav = library.querySelector('.edas-content-library__pagination');
        if (!nav || library.dataset.paginationBound) {
            return;
        }
        library.dataset.paginationBound = '1';

        var totalPages = parseInt(nav.getAttribute('data-total-pages') || '1', 10);
        if (isNaN(totalPages) || totalPages <= 1) {
            return;
        }

        nav.addEventListener('click', function (event) {
            var btn = event.target.closest('[data-page-dir]');
            if (!btn || !nav.contains(btn) || btn.disabled) {
                return;
            }
            event.preventDefault();
            var current = parseInt(library.getAttribute('data-current-page') || '1', 10);
            if (isNaN(current)) {
                current = 1;
            }
            var dir = btn.getAttribute('data-page-dir');
            var nextPage = dir === 'prev' ? current - 1 : current + 1;
            showPage(library, nextPage);
        });

        updatePaginationUi(library, 1, totalPages);
    }

    function storageKey(libraryId, attachmentId) {
        return 'edas_cl_likes:' + libraryId + ':' + attachmentId;
    }

    function readLiked(libraryId, attachmentId) {
        try {
            return window.localStorage.getItem(storageKey(libraryId, attachmentId)) === '1';
        } catch (e) {
            return false;
        }
    }

    function writeLiked(libraryId, attachmentId, liked) {
        try {
            var key = storageKey(libraryId, attachmentId);
            if (liked) {
                window.localStorage.setItem(key, '1');
            } else {
                window.localStorage.removeItem(key);
            }
        } catch (e) {
            // Ignore quota / private mode.
        }
    }

    function setLikeUi(btn, liked, count, animate) {
        var label = btn.querySelector('[data-like-count-label]');
        btn.classList.toggle('is-liked', !!liked);
        btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
        if (label) {
            label.textContent = String(Math.max(0, count));
        }
        var post = btn.closest('.edas-content-library__post');
        if (post) {
            post.setAttribute('data-like-count', String(Math.max(0, count)));
        }
        if (animate && liked) {
            btn.classList.remove('is-animating');
            // Force reflow so animation can restart.
            void btn.offsetWidth;
            btn.classList.add('is-animating');
            window.setTimeout(function () {
                btn.classList.remove('is-animating');
            }, 450);
        }
    }

    function likesConfig() {
        return window.edasContentLibraryLikes || {};
    }

    function applyFreshNonce(nonce) {
        if (typeof nonce === 'string' && nonce && window.edasContentLibraryLikes) {
            window.edasContentLibraryLikes.nonce = nonce;
        }
    }

    function fetchLikeCounts(libraryId, attachmentIds) {
        var cfg = likesConfig();
        if (!cfg.ajaxUrl || !cfg.getAction || !libraryId || !attachmentIds.length) {
            return Promise.resolve(null);
        }

        var body = new window.FormData();
        body.append('action', cfg.getAction);
        body.append('library_id', libraryId);
        attachmentIds.forEach(function (id) {
            body.append('attachment_ids[]', String(id));
        });

        return window.fetch(cfg.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: body,
        }).then(function (res) {
            return res.json();
        }).then(function (json) {
            if (!json || !json.success || !json.data) {
                throw new Error((json && json.data && json.data.message) || 'get_likes_failed');
            }
            applyFreshNonce(json.data.nonce);
            return json.data;
        });
    }

    function postLike(libraryId, attachmentId, delta) {
        var cfg = likesConfig();
        if (!cfg.ajaxUrl || !cfg.nonce || !cfg.action) {
            return Promise.reject(new Error('likes_config_missing'));
        }

        var body = new window.FormData();
        body.append('action', cfg.action);
        body.append('nonce', cfg.nonce);
        body.append('library_id', libraryId);
        body.append('attachment_id', String(attachmentId));
        body.append('delta', String(delta));

        return window.fetch(cfg.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: body,
        }).then(function (res) {
            return res.json();
        }).then(function (json) {
            if (!json || !json.success || !json.data) {
                throw new Error((json && json.data && json.data.message) || 'like_failed');
            }
            applyFreshNonce(json.data.nonce);
            return json.data;
        });
    }

    function initLikes(library) {
        if (library.dataset.likesBound) {
            return;
        }
        if (!library.querySelector('[data-like-toggle]')) {
            return;
        }
        library.dataset.likesBound = '1';

        var libraryId = library.getAttribute('data-library-id') || '';
        var attachmentIds = [];

        library.querySelectorAll('.edas-content-library__post').forEach(function (post) {
            var btn = post.querySelector('[data-like-toggle]');
            if (!btn) {
                return;
            }
            var postLibraryId = post.getAttribute('data-library-id') || libraryId;
            var attachmentId = post.getAttribute('data-attachment-id') || '';
            var count = parseInt(post.getAttribute('data-like-count') || '0', 10);
            if (isNaN(count)) {
                count = 0;
            }
            var liked = readLiked(postLibraryId, attachmentId);
            setLikeUi(btn, liked, count, false);
            if (attachmentId) {
                attachmentIds.push(attachmentId);
            }
        });

        // Refresh counts + nonce via admin-ajax (bypasses WP Fastest Cache HTML).
        if (libraryId && attachmentIds.length) {
            fetchLikeCounts(libraryId, attachmentIds)
                .then(function (data) {
                    if (!data || !data.counts) {
                        return;
                    }
                    library.querySelectorAll('.edas-content-library__post').forEach(function (post) {
                        var btn = post.querySelector('[data-like-toggle]');
                        if (!btn) {
                            return;
                        }
                        var attachmentId = post.getAttribute('data-attachment-id') || '';
                        if (!attachmentId || typeof data.counts[attachmentId] === 'undefined') {
                            return;
                        }
                        var postLibraryId = post.getAttribute('data-library-id') || libraryId;
                        setLikeUi(btn, readLiked(postLibraryId, attachmentId), data.counts[attachmentId], false);
                    });
                })
                .catch(function () {
                    // Keep SSR / cached counts as fallback.
                });
        }

        library.addEventListener('click', function (event) {
            var btn = event.target.closest('[data-like-toggle]');
            if (!btn || !library.contains(btn)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();

            if (btn.dataset.likeBusy === '1') {
                return;
            }

            var post = btn.closest('.edas-content-library__post');
            if (!post) {
                return;
            }

            var libraryId = post.getAttribute('data-library-id') || library.getAttribute('data-library-id') || '';
            var attachmentId = post.getAttribute('data-attachment-id') || '';
            if (!libraryId || !attachmentId) {
                return;
            }

            var count = parseInt(post.getAttribute('data-like-count') || '0', 10);
            if (isNaN(count)) {
                count = 0;
            }
            var wasLiked = readLiked(libraryId, attachmentId);
            var nextLiked = !wasLiked;
            var delta = nextLiked ? 1 : -1;
            var optimisticCount = Math.max(0, count + delta);

            btn.dataset.likeBusy = '1';
            writeLiked(libraryId, attachmentId, nextLiked);
            setLikeUi(btn, nextLiked, optimisticCount, nextLiked);

            postLike(libraryId, attachmentId, delta)
                .then(function (data) {
                    var serverCount = typeof data.count === 'number' ? data.count : optimisticCount;
                    setLikeUi(btn, nextLiked, serverCount, false);
                })
                .catch(function () {
                    writeLiked(libraryId, attachmentId, wasLiked);
                    setLikeUi(btn, wasLiked, count, false);
                })
                .then(function () {
                    btn.dataset.likeBusy = '0';
                });
        });
    }

    function initLibrary(library) {
        if (library.dataset.libraryBound) {
            return;
        }
        library.dataset.libraryBound = '1';

        var lightbox = library.querySelector('.edas-content-library-lightbox');
        if (lightbox) {
            bindLightbox(library, lightbox);
        }
        initPagination(library);
        initLikes(library);
    }

    document.addEventListener('keydown', function (event) {
        if (!activeLightbox) {
            return;
        }
        if (event.key === 'Escape') {
            closeLightbox(activeLightbox);
        } else if (event.key === 'ArrowLeft') {
            stepLightbox(activeLightbox, -1);
        } else if (event.key === 'ArrowRight') {
            stepLightbox(activeLightbox, 1);
        }
    });

    function initAll() {
        document.querySelectorAll('.edas-content-library').forEach(initLibrary);
        bindEntryImages();
        refreshLucide(document);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
})();
